(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ZoneFormController', ZoneFormController);
    

    ZoneFormController.$inject = [
        '$timeout', 'NgMap', 'fleet', 'endPoints', '$stateParams', '$q', 'genericDataService', '$scope'
    ];

     function ZoneFormController($timeout, NgMap, fleet, endPoints, $stateParams, $q, genericDataService, $scope){
         // jshint maxstatements:false
        var vm = this;
        vm.googleApiURL = endPoints.GOOGLE_MAPS_API_URL;

        $scope.$on('detail-resize', function(event, args) {
            $timeout(function(){ /*console.log('RESIZE!');*/ },0);
        });
    } 

})();

